import { Component, OnInit } from '@angular/core';

import { GridDataResult, GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

import {environment} from '../../environments/environment';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
  report: Report;
  gridData: Array<any> = [];
  gridView: GridDataResult;
  sort: SortDescriptor[] = [];
  progress: Array<any>;

  state: State = {
    skip: 0,
    take: 50
  };

  constructor(private reportService: ReportDataService) {
    this.report = reportService.getReport();
  }

  ngOnInit() {
    this.progress = this.report.getProgress();
  }


  getStatusClass(status) {
    let styles = ['badge', 'badge-pill'];
    if (status === 'Complete') {
      styles.push('badge-success');
    } else if (status === 'Incomplete') {
      styles.push('badge-danger');
    } else {
      styles.push('badge-warning');
    }
    return styles;
  }
}



// WEBPACK FOOTER //
// ./src/app/progress/progress.component.ts